"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ChatComposer = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ChatComposer, _PureComponent);

  var _super = _createSuper(ChatComposer);

  function ChatComposer() {
    var _this;

    (0, _classCallCheck2.default)(this, ChatComposer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      value: ''
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInput", function (e) {
      _this.setState({
        value: e.target.value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", function (e) {
      e.preventDefault();

      var trimmed = _this.state.value.trim();

      if (!trimmed || _this.props.disabled) return;

      _this.props.onSend(trimmed);

      _this.setState({
        value: ''
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ChatComposer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder;
      return (0, _preact.h)("form", {
        className: "forethought-agent__composer",
        onSubmit: this.handleSubmit
      }, (0, _preact.h)("input", {
        type: "text",
        className: "forethought-agent__composer-input",
        value: this.state.value,
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Ask a follow-up…',
        disabled: disabled,
        onInput: this.handleInput
      }), (0, _preact.h)("button", {
        type: "submit",
        className: "forethought-agent__composer-send",
        disabled: disabled || !this.state.value.trim()
      }, "Send"));
    }
  }]);
  return ChatComposer;
}(_preactCompat.PureComponent);

var _default = ChatComposer;
exports.default = _default;